import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import ShareViaSms from './ShareViaSms.jsx';
import {sendResultsViaSms} from '@ignitesales/neuro-application/src/actions/social-action-creators';
import {actionCompleted, actionStarted} from '@ignitesales/neuro-application/src/actions/question-action-creators';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({component: 'ShareViaTexas'});

const ConnectedShareViaSms = props => {
  const {
    hasBeenClicked,
    actionStarted,
    actionCompleted,
    sendResultsViaTextMessage,
    ...rest
  } = props;

  useEffect(() => {
    if(hasBeenClicked){
      actionStarted();
    }
  });

  const sendTextMessage = phoneNumber => {
    actionCompleted();
    try {
      sendResultsViaTextMessage(phoneNumber);
    } catch(e) {
      logger.error('An error occurred while sending text message', {phoneNumber}, e );
    }
  };

  return  <ShareViaSms {...rest} sendTextMessage={sendTextMessage} />;
};

export default connect(
  () => {}, dispatch => {
    return {
      sendResultsViaTextMessage: phone => {
        dispatch(sendResultsViaSms(phone));
      },
      actionStarted: () => {
        dispatch(actionStarted({actionName: 'shareViaSmsClicked'}));
      },
      actionCompleted: () => {
        dispatch(actionCompleted({actionName: 'shareViaSmsClicked'}));
      },
    };
  })(ConnectedShareViaSms);
